export default __webpack_public_path__ + "static/style-tip-confidence-4e9455b6e617b08af71aa80de1dd011b.png";